import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    ViewChild,
    forwardRef,
    DoCheck,
    Injector,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Document } from 'src/app/acl-data/document/document.dto';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    NgControl,
} from '@angular/forms';
import { DocumentService } from 'src/app/acl-data/document/document.service';
import { take } from 'rxjs/operators';
import { LinkDocumentDialogComponent } from 'src/app/acl-search/link-document-dialog/link-document-dialog.component';

// tslint:disable-next-line: no-conflicting-lifecycle
@Component({
    selector: 'app-linked-documents-view',
    templateUrl: './linked-documents-view.component.html',
    styleUrls: ['./linked-documents-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LinkedViewComponent),
            multi: true,
        },
    ],
})
export class LinkedViewComponent
    implements OnChanges, ControlValueAccessor, DoCheck {
    documents: Document[] = [];
    @Input() documentID;
    @Input() addButton = false;

    @Input() folderID: string;
    @Input() objectStore: string;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    displayedColumns: string[] = this.addButton
        ? ['Action', 'ContractIdentifier', 'Name', 'FoldersFiledIn']
        : ['ContractIdentifier', 'Name', 'FoldersFiledIn'];
    dataSource;

    onChanges = [];
    onTouched = [];
    touched = false;
    disabled = false;

    constructor(
        public dialog: MatDialog,
        private documentService: DocumentService,
        private injector: Injector
    ) {}

    ngOnChanges() {
        this.displayedColumns = this.addButton
            ? ['Action', 'ContractIdentifier', 'Name', 'FoldersFiledIn']
            : ['ContractIdentifier', 'Name', 'FoldersFiledIn'];

        if (this.documents) {
            this.dataSource = new MatTableDataSource<Document>(this.documents);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        }
    }

    selectLinkedDocuments = (input: any) => {
        const dialogRef = this.dialog.open(LinkDocumentDialogComponent, {
            width: '80%',
            height: '80%',
            data: {
                folderID: this.folderID,
                objectStore: this.objectStore,
                excludedIDs: [
                    this.documentID,
                    ...this.documents.map(v => v.id),
                ],
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.length > 0) {
                // console.log('The dialog was closed', result);
                // this.documentService
                //     .getByIds(this.objectStore, result, true)
                //     .pipe(take(1))
                //     .subscribe(_ => {
                //         return;
                //     });

                const newList = [...result, ...this.documents.map(v => v.id)];
                this.formChanged(newList);
                this.writeValue(newList);
            }
        });
    };

    delete = element => {
        this.documents = this.documents.filter(v => v !== element);
        const result = this.documents.map(v => v.id);
        this.formChanged(result);
        this.writeValue(result);
    };

    formChanged = (input: any) => {
        for (const change of this.onChanges) {
            change(input);
        }
    };

    writeValue(obj: string[]): void {
        if (obj && obj.length > 0) {
            // console.log('Link Documents', obj);
            this.documentService
                .getByIds(this.objectStore, obj)
                .subscribe(v => {
                    this.documents = v;
                    this.ngOnChanges();
                });
        }
    }

    ngDoCheck() {
        const ngControl = this.injector.get(NgControl);
        if (!ngControl.control) {
            return;
        }
        this.touched = ngControl.control.touched;
    }

    private setOnChangeCallback(fn: any) {
        this.onChanges.push(fn);
    }

    private setOnTouchCallback(fn: any) {
        this.onTouched.push(fn);
    }

    setIsDisabled(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // console.log('registerOnChange');
        this.setOnChangeCallback(fn);
    }
    registerOnTouched(fn: any): void {
        this.setOnTouchCallback(fn);
    }
    setDisabledState?(isDisabled: boolean): void {
        this.setIsDisabled(isDisabled);
    }
}
